import { render, staticRenderFns } from "./BookmarkFeed.vue?vue&type=template&id=5f399109&scoped=true&"
import script from "./BookmarkFeed.vue?vue&type=script&lang=ts&"
export * from "./BookmarkFeed.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkFeed.vue?vue&type=style&index=0&id=5f399109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f399109",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
